import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getFunctions } from "firebase/functions";
import { getAI, GoogleAIBackend } from 'firebase/ai';
//import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';  // Add App Check import

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD7BgHMVbPExHLBIdXAMtlc-I8RldNNDVw",
  authDomain: "sonoma.school",
  projectId: "cbsms-da9ce",
  storageBucket: "cbsms-da9ce.firebasestorage.app",
  messagingSenderId: "586530353363",
  appId: "1:586530353363:web:5975d8993c760756446426",
  measurementId: "G-W3JVMBRND9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);
const ai = getAI(app, { backend: new GoogleAIBackend() });
//const appCheck = initializeAppCheck(app, {
// provider: new ReCaptchaV3Provider('your-recaptcha-site-key'),  // Replace with your reCAPTCHA v3 site key
// isTokenAutoRefreshEnabled: true
//});

export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, "us-central1");

// PASTE YOUR RECAPTCHA V3 SITE KEY HERE
// IMPORTANT: Only use the "Site Key" (starts with 6L...). Do NOT use the "Secret Key" here.
export const recaptchaKey = "6LcRJBMsAAAAAIqrKLLrxzhZTgTFCrPl4bSJU_7S";

export { storage, app, ai };  // Export appCheck